import React, { useState, useContext, FormEvent } from "react";
import { Link as RouterLink } from "react-router-dom";

import {
    Context as AuthContext,
    ActionType as AuthActionType,
} from "../context/Auth";
import {
    Context as IntegrationsContext,
    ActionType as IntegrationsActionType,
} from "../context/Integrations";
import { useService as useSessionService } from "../services/Sessions";

import Button from "../components/Button";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Divider from "@mui/material/Divider";
import GoogleIcon from "@mui/icons-material/Google";

import { FormField, PasswordField } from "../components/InputFields";

// TODO Mostly copied from Signup page. Maybe make a CenteredCard component for this.
const Login = () => {
    const service = useSessionService();

    const { dispatch: authDispatch } = useContext(AuthContext);
    const { dispatch: integrationsDispatch } = useContext(IntegrationsContext);

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        try {
            setLoading(true);

            try {
                const res = await service.login(
                    {
                        email: email.toLowerCase().trim(),
                        password,
                    },
                    true,
                );

                authDispatch({
                    type: AuthActionType.LOGIN,
                    payload: res,
                });
                integrationsDispatch({
                    type: IntegrationsActionType.SET_INTEGRATIONS,
                    payload: res.integrations,
                });
            } catch (err: any) {
                throw err;
            }
        } catch (err) {
            console.error(err);
        }

        setLoading(false);
    };

    const getGoogleLoginURL = async () => {
        try {
            setLoading(true);
            const res = await service.loginWithGoogle();
            window.location.href = res.url;
        } catch (err) {
            console.error(err);
        }
        setLoading(false);
    };

    return (
        <form onSubmit={onSubmit}>
            <Grid
                container
                alignItems="center"
                justifyContent="center"
                style={{ minHeight: "100vh" }}
            >
                <Grid item xs={12} sm={8} md={6} lg={4}>
                    <Box px={5}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            spacing={2}
                        >
                            <Grid item>
                                <Typography variant="h6" mb={4}>
                                    Sign in to Text Voice
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Button
                                    type="button"
                                    onClick={getGoogleLoginURL}
                                    variant="contained"
                                    color="primary"
                                    disabled={loading}
                                    size="large"
                                    fullWidth
                                >
                                    <GoogleIcon sx={{ marginRight: "10px" }} />{" "}
                                    Sign In With Google
                                </Button>
                            </Grid>
                            <Grid item>
                                <Box mt={4} />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                    >
                                        OR
                                    </Typography>
                                </Divider>
                            </Grid>

                            <>
                                <Grid item>
                                    <FormField
                                        required
                                        label="Email"
                                        value={email}
                                        onChange={(e) =>
                                            setEmail(e.target.value)
                                        }
                                        type="email"
                                    />
                                </Grid>

                                <Grid item>
                                    <PasswordField
                                        required
                                        label="Password"
                                        value={password}
                                        onChange={(e) =>
                                            setPassword(e.target.value)
                                        }
                                        showPassword={showPassword}
                                        setShowPassword={setShowPassword}
                                    />
                                </Grid>

                                <Grid item>
                                    <Typography align="right" variant="body2">
                                        <Link
                                            component={RouterLink}
                                            to="/forgot_password"
                                        >
                                            Forgot your password
                                        </Link>
                                    </Typography>
                                </Grid>
                            </>

                            <Grid item>
                                <Button
                                    type="submit"
                                    variant="outlined"
                                    color="primary"
                                    disabled={loading}
                                    fullWidth
                                    size="large"
                                >
                                    Sign In
                                </Button>
                            </Grid>

                            <Grid item>
                                <Box mt={4} />
                            </Grid>

                            <Grid item>
                                <Typography align="center" variant="body1">
                                    New to Text Voice?{" "}
                                    <Link component={RouterLink} to="/signup">
                                        Create account
                                    </Link>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </form>
    );
};

export default Login;
